/**
 * Points display helpers (T4 — one money model).
 *
 * "Available" is the single number members see across the app: points they can
 * spend right now. The API computes points_available = total_points − pending
 * (apps/api/src/routes/member.ts), which equals the redemption page's confirmed
 * balance. Nav + dashboard both read through getAvailablePoints() so they can
 * never visibly disagree.
 */
type MePoints = { points_available?: number; points_balance?: number } | null | undefined;

/** The member's spendable balance, in points. */
export function getAvailablePoints(me: MePoints): number {
  return me?.points_available ?? me?.points_balance ?? 0;
}

/** Points → USD at the platform rate (100 pts = $1.00). */
export function pointsToUsd(points: number): string {
  return (points / 100).toFixed(2);
}

/**
 * Whole days until a pending batch releases, floored at 0. Used for the
 * "unlocking · first batch in N days" countdown.
 */
export function daysUntil(iso: string, now: number = Date.now()): number {
  const ms = new Date(iso).getTime() - now;
  return Math.max(0, Math.ceil(ms / 86_400_000));
}
